export const voiceTableConfig = {
  propList: [
    {prop: 'empName', label: '业务员', minWidth: '90', slotName: 'consumer'},
    {prop: 'callCount', label: '通话次数', minWidth: '120', sortable: true},
    {prop: 'customerCount', label: '通话客户数', minWidth: '140', sortable: true},
    {prop: 'callDuration', label: '通话总时长（分钟）', minWidth: '180', slotName: 'callDuration', sortable: true},
    {prop: 'averageCount', label: '平均通话时长（分钟）', minWidth: '190', slotName: 'averageCount', sortable: true}
  ]
}
